module.exports = __webpack_public_path__ + "static/media/supporting-diverse-customers.0d4fbd70.jpg";